import { createSlice } from '../../../../utils/@reduxjs/toolkit';
import { SingleItemState } from './types';
import { reducers } from './reducers';

export const initialState: SingleItemState = {
  isLoading: false,
  error: null,
  data: null,
};

const slice = createSlice({
  name: 'singleItem',
  initialState,
  reducers,
});

export const { actions: singleItemActions } = slice;
export const { reducer: singleItemReducer } = slice;
